import React from 'react';
const ProgramList = () => {
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};
export default ProgramList;